import { defineStore } from 'pinia'
export default defineStore({
  id: 'workflowDataTable',
  persist: true,
  state: () => {
    return {
      isWorkflowArchive: false
    }
  },
  actions: {
    setIsWorkflowArchive: function (payload: any) {
      this.isWorkflowArchive = payload
    }
  },
  getters: {
    getIsWorkflowArchive: (state: any) => state.isWorkflowArchive
  }
})
